var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 18.75V6.25H43.75V18.75H27.0833ZM6.25 27.0833V6.25H22.9167V27.0833H6.25ZM27.0833 43.75V22.9167H43.75V43.75H27.0833ZM6.25 43.75V31.25H22.9167V43.75H6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsDashboard);
export default __webpack_public_path__ + "static/media/material-symbols_dashboard.afdd37d5ef8f19881ccb2c53bad04803.svg";
export { ForwardRef as ReactComponent };